"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Naomi = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const constants_1 = require("../../constants");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
class Naomi extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.NAOMI,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L14',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.colonies(1).colon().energy(2).megacredits(3);
                    b.br.br.br;
                    b.opgArrow().text('SET ALL').colonies(1).asterix();
                }),
                description: 'When you build a colony, gain 2 energy and 3 M€. Once per game, move each colony tile track marker to its highest or lowest value.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        if (player.game.gameOptions.coloniesExtension === false)
            return false;
        const openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
        return openColonies.length > 0 && this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const activeColonies = game.colonies.filter((colony) => colony.isActive);
        activeColonies.forEach((colony) => {
            game.defer(new DeferredAction_1.DeferredAction(player, () => new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Increase ' + colony.name + ' track to its highest value', 'Select', () => {
                colony.trackPosition = constants_1.MAX_COLONY_TRACK_POSITION;
                return undefined;
            }), new SelectOption_1.SelectOption('Decrease ' + colony.name + ' track to its lowest value', 'Select', () => {
                colony.trackPosition = colony.colonies.length;
                return undefined;
            }))));
        });
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            this.isDisabled = true;
            return undefined;
        }));
        return undefined;
    }
}
exports.Naomi = Naomi;
//# sourceMappingURL=Naomi.js.map